import {
  Collapse,
  Card,
  Image,
  List,
  Button,
  Space,
  Tag,
  Typography,
  Empty,
  Modal,
  Badge,
  Tooltip,
  message,
  Row,
  Col,
  Input,
  Spin,
} from "antd";
import {
  FileTextOutlined,
  FilePdfOutlined,
  FileImageOutlined,
  DownloadOutlined,
  EyeOutlined,
  FileOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  UserOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  baseUrl,
  GET_DETAILS,
  GET_LOAN_BY_CONTNO,
  HEADERS_EXPORT,
} from "../../API/apiUrls";
import axios from "axios";
import { PARAM_PUBLIC } from "../../../utils/constant/StatusConstant";

const { Text, Title } = Typography;

const Main = () => {
  const [loading, setLoading] = useState(false);
  const [dataLoadLoan, setDataLoadLoan] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [dataStatus, setDataStatus] = useState(null);
  const [documents, setDocuments] = useState({
    termination: [], // จดหมายบอกเลิก
    lawsuit: [], // คำฟ้อง
    judgment: [], // คำพิพากษา
    enforcement: [], // หมายคดีบังคับคดี
    settlement: [], // ปิดคดี/รีไฟแนนซ์
  });

  const onChangeInputSearchLoad = (value) => {
    setSearchInput(value);
  };

  const handleLoad = () => {
    if (searchInput) {
      loadLoan();
    } else {
      message.warning("กรุณากรอกเลขที่สัญญา");
    }
  };

  const loadLoan = async () => {
    setLoading(true);

    // Reset documents
    setDocuments({
      termination: [],
      lawsuit: [],
      judgment: [],
      enforcement: [],
      settlement: [],
    });

    try {
      const [resDetails, resLoan] = await Promise.all([
        axios.get(baseUrl + GET_DETAILS + searchInput, {
          headers: HEADERS_EXPORT,
        }),
        axios.get(baseUrl + GET_LOAN_BY_CONTNO + searchInput, {
          headers: HEADERS_EXPORT,
        }),
      ]);

      if (resDetails.status === 200) {
        console.log("Details:", resDetails.data);
        setDataStatus(resDetails.data);
        await loadImages(resDetails.data);
      }

      if (resLoan.status === 200) {
        console.log("Loan:", resLoan.data);
        setDataLoadLoan(resLoan.data);
      }
    } catch (error) {
      console.error("Error loading data:", error);
      message.error("ไม่พบข้อมูล");
      setDataLoadLoan(null);
      setDataStatus(null);
    } finally {
      setLoading(false);
    }
  };

  const loadImages = async (data) => {
    const newDocuments = {
      termination: [],
      lawsuit: [],
      judgment: [],
      enforcement: [],
      settlement: [],
    };

    try {
      // ✅ จดหมายบอกเลิก
      if (data?.cancel_contract?.length > 0) {
        const sortedData = data.cancel_contract.sort((a, b) => {
          if (a.contract_no === b.contract_no) {
            return a.customer_type_id - b.customer_type_id;
          }
          return a.contract_no.localeCompare(b.contract_no);
        });

        for (const item of sortedData) {
          if (item.status) {
            try {
              const response = await axios.get(
                `${baseUrl}/files/lawyer/cancel_contract/${PARAM_PUBLIC}/${searchInput}${item.parcel_no_response}`,
              );

              if (response.data?.length > 0) {
                newDocuments.termination.push(...response.data);
              }
            } catch (err) {
              console.error("Error loading termination:", err);
            }
          }
        }
      }

      // ✅ คำฟ้อง
      if (data?.STATUS3) {
        try {
          const response = await axios.get(
            `${baseUrl}/files/lawyer/lawsuit/${PARAM_PUBLIC}/black-number_${searchInput}`,
          );

          if (response.data?.length > 0) {
            newDocuments.lawsuit.push(...response.data);
          }
        } catch (err) {
          console.error("Error loading lawsuit:", err);
        }
      }

      // ✅ คำพิพากษา และเอกสารบังคับคดี
      if (data?.STATUS4 || data?.STATUS8) {
        try {
          // ✅ คำพิพากษา - ลองทีละแบบ
          const judgmentPatterns = [
            `judgement${searchInput}`, // แบบที่ 1: ไม่มี underscore
            `judgement_${searchInput}`, // แบบที่ 2: มี underscore
            `judgement_${searchInput}/${searchInput}`, // แบบที่ 3: มี underscore + searchInput
          ];

          let judgmentFound = false;
          for (const pattern of judgmentPatterns) {
            try {
              console.log(`🔍 กำลังลอง: ${pattern}`);
              const judgmentRes = await axios.get(
                `${baseUrl}/files/lawyer/enforcement/${PARAM_PUBLIC}/${pattern}`,
              );

              if (judgmentRes.data?.length > 0) {
                newDocuments.judgment.push(...judgmentRes.data);
                console.log(
                  `✅ พบคำพิพากษา: ${pattern} (${judgmentRes.data.length} ไฟล์)`,
                );
                judgmentFound = true;
                break; // เจอแล้วออกจาก loop ไม่ต้องลองแบบอื่นแล้ว
              } else {
                console.log(`⚠️ ไม่มีข้อมูลใน: ${pattern}`);
              }
            } catch (err) {
              console.log(`❌ ไม่พบ: ${pattern} - ลองแบบถัดไป...`);
              // ไม่ throw error ให้ลองแบบถัดไปต่อ
            }
          }

          if (!judgmentFound) {
            console.log("ℹ️ ไม่พบเอกสารคำพิพากษาทุกรูปแบบ");
          }

          // ✅ หมายคดีตั้ง
          try {
            const enforceRes = await axios.get(
              `${baseUrl}/files/lawyer/enforcement/${PARAM_PUBLIC}/enforce-case_${searchInput}`,
            );
            if (enforceRes.data?.length > 0) {
              newDocuments.enforcement.push(...enforceRes.data);
              console.log(`✅ พบหมายคดีตั้ง: ${enforceRes.data.length} ไฟล์`);
            }
          } catch (err) {
            console.log("❌ ไม่พบหมายคดีตั้ง");
          }

          // ✅ คดีถึงที่สุด
          try {
            const finalRes = await axios.get(
              `${baseUrl}/files/lawyer/enforcement/${PARAM_PUBLIC}/final-case_${searchInput}`,
            );
            if (finalRes.data?.length > 0) {
              newDocuments.enforcement.push(...finalRes.data);
              console.log(`✅ พบคดีถึงที่สุด: ${finalRes.data.length} ไฟล์`);
            }
          } catch (err) {
            console.log("❌ ไม่พบคดีถึงที่สุด");
          }
        } catch (err) {
          console.error("Error loading judgment/enforcement:", err);
        }
      }
      if (data?.STATUS10) {
        try {
          const response = await axios.get(
            `${baseUrl}/files/lawyer/seize_assets/${PARAM_PUBLIC}/report-seize_${searchInput}`,
          );
          if (response.data?.length > 0) {
            newDocuments.enforcement.push(...response.data);
          }
        } catch (err) {
          console.error("Error loading settlement:", err);
        }
      }
      // ✅ ปิดคดี/รีไฟแนนซ์
      if (data?.STATUS11) {
        try {
          const response = await axios.get(
            `${baseUrl}/files/lawyer/settlement_agreement/${PARAM_PUBLIC}/agreement${searchInput}`,
          );

          if (response.data?.length > 0) {
            newDocuments.settlement.push(...response.data);
          }
        } catch (err) {
          console.error("Error loading settlement:", err);
        }
      }
      console.log(newDocuments);

      // อัพเดท state
      setDocuments(newDocuments);
    } catch (error) {
      console.error("Error in loadImages:", error);
    }
  };

  // ✅ แยกชื่อไฟล์จาก path
  const getFileName = (filePath) => {
    if (!filePath) return "ไม่ทราบชื่อไฟล์";
    const parts = filePath.split("/");
    const fileName = parts[parts.length - 1];
    try {
      return decodeURIComponent(fileName);
    } catch {
      return fileName;
    }
  };

  // ✅ ตรวจสอบประเภทไฟล์
  const getFileType = (fileName) => {
    const ext = fileName.toLowerCase().split(".").pop();
    if (["pdf"].includes(ext)) return "pdf";
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    return "file";
  };

  // ✅ ดูไฟล์
  const handleView = (file) => {
    const fileType = getFileType(file.name);

    if (fileType === "pdf") {
      window.open(file.url, "_blank");
    } else if (fileType === "image") {
      Modal.info({
        title: getFileName(file.name),
        width: 800,
        icon: null,
        content: (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Image
              src={file.url}
              alt={getFileName(file.name)}
              style={{ maxWidth: "100%" }}
            />
          </div>
        ),
        okText: "ปิด",
      });
    } else {
      window.open(file.url, "_blank");
    }
  };

  // ✅ ดาวน์โหลดไฟล์
  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = file.url;
    link.download = getFileName(file.name);
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    message.success("กำลังดาวน์โหลดไฟล์...");
  };

  // ✅ สร้าง File List Item
  const renderFileItem = (file, index) => {
    const fileName = getFileName(file.name);
    const fileType = getFileType(file.name);

    return (
      <List.Item
        key={index}
        style={{
          padding: "16px 20px",
          borderRadius: "12px",
          background: "#ffffff",
          marginBottom: "12px",
          border: "1px solid #e8e8e8",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <List.Item.Meta
          avatar={
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: "10px",
                overflow: "hidden",
                border: "2px solid #e8e8e8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: fileType === "pdf" ? "#fff1f0" : "#f0f5ff",
              }}
            >
              {fileType === "pdf" ? (
                <FilePdfOutlined style={{ fontSize: 32, color: "#ff4d4f" }} />
              ) : fileType === "image" ? (
                <FileImageOutlined style={{ fontSize: 32, color: "#1890ff" }} />
              ) : (
                <FileOutlined style={{ fontSize: 32, color: "#8c8c8c" }} />
              )}
            </div>
          }
          title={
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              <Text
                strong
                style={{
                  fontSize: 15,
                  display: "block",
                  maxWidth: "500px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={fileName}
              >
                {fileName}
              </Text>
              <Space size={8}>
                <Tag
                  icon={<CheckCircleOutlined />}
                  color="success"
                  style={{ fontSize: 12 }}
                >
                  พร้อมใช้งาน
                </Tag>
                {fileType === "pdf" && (
                  <Tag color="red" style={{ fontSize: 12 }}>
                    <FilePdfOutlined /> PDF
                  </Tag>
                )}
                {fileType === "image" && (
                  <Tag color="blue" style={{ fontSize: 12 }}>
                    <FileImageOutlined /> รูปภาพ
                  </Tag>
                )}
              </Space>
            </Space>
          }
        />
        <Space size="middle">
          <Tooltip title="ดูไฟล์">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => handleView(file)}
              style={{ borderRadius: "8px" }}
            >
              ดู
            </Button>
          </Tooltip>
          <Tooltip title="ดาวน์โหลด">
            <Button
              icon={<DownloadOutlined />}
              onClick={() => handleDownload(file)}
              style={{ borderRadius: "8px" }}
            >
              ดาวน์โหลด
            </Button>
          </Tooltip>
        </Space>
      </List.Item>
    );
  };

  // ✅ สร้าง Collapse Items
  const collapseItems = [
    {
      key: "1",
      label: (
        <Space size={12}>
          <FileOutlined style={{ fontSize: 20, color: "#ff4d4f" }} />
          <Text strong style={{ fontSize: 16 }}>
            จดหมายบอกเลิกสัญญา
          </Text>
          <Badge
            count={documents.termination.length}
            style={{ backgroundColor: "#ff4d4f" }}
            showZero
          />
        </Space>
      ),
      children: (
        <Card style={{ background: "#fafafa", padding: "16px" }}>
          {documents.termination.length > 0 ? (
            <List
              dataSource={documents.termination}
              renderItem={(file, index) => renderFileItem(file, index)}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="ไม่พบเอกสารจดหมายบอกเลิกสัญญา"
            />
          )}
        </Card>
      ),
    },
    {
      key: "2",
      label: (
        <Space size={12}>
          <FileTextOutlined style={{ fontSize: 20, color: "#1890ff" }} />
          <Text strong style={{ fontSize: 16 }}>
            คำฟ้อง
          </Text>
          <Badge
            count={documents.lawsuit.length}
            style={{ backgroundColor: "#1890ff" }}
            showZero
          />
        </Space>
      ),
      children: (
        <Card style={{ background: "#fafafa", padding: "16px" }}>
          {documents.lawsuit.length > 0 ? (
            <List
              dataSource={documents.lawsuit}
              renderItem={(file, index) => renderFileItem(file, index)}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="ไม่พบเอกสารคำฟ้อง"
            />
          )}
        </Card>
      ),
    },
    {
      key: "3",
      label: (
        <Space size={12}>
          <FilePdfOutlined style={{ fontSize: 20, color: "#52c41a" }} />
          <Text strong style={{ fontSize: 16 }}>
            คำพิพากษา
            {dataStatus?.agreement && dataStatus?.judge
              ? " (ทำยอม)"
              : dataStatus?.judge
                ? " (พิพากษาฝ่ายเดียว)"
                : null}
          </Text>
          <Badge
            count={documents.judgment.length}
            style={{ backgroundColor: "#52c41a" }}
            showZero
          />
        </Space>
      ),
      children: (
        <Card style={{ background: "#fafafa", padding: "16px" }}>
          {documents.judgment.length > 0 ? (
            <List
              dataSource={documents.judgment}
              renderItem={(file, index) => renderFileItem(file, index)}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="ไม่พบเอกสารคำพิพากษา"
            />
          )}
        </Card>
      ),
    },
    {
      key: "4",
      label: (
        <Space size={12}>
          <FileTextOutlined style={{ fontSize: 20, color: "#fa8c16" }} />
          <Text strong style={{ fontSize: 16 }}>
            เอกสารบังคับคดี
          </Text>
          <Badge
            count={documents.enforcement.length}
            style={{ backgroundColor: "#fa8c16" }}
            showZero
          />
        </Space>
      ),
      children: (
        <Card
          bordered={false}
          style={{ background: "#fafafa" }}
          bodyStyle={{ padding: "16px" }}
        >
          {documents.enforcement.length > 0 ? (
            <List
              dataSource={documents.enforcement}
              renderItem={(file, index) => renderFileItem(file, index)}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="ไม่พบเอกสารบังคับคดี"
            />
          )}
        </Card>
      ),
    },
    {
      key: "5",
      label: (
        <Space size={12}>
          <CheckCircleOutlined style={{ fontSize: 20, color: "#722ed1" }} />
          <Text strong style={{ fontSize: 16 }}>
            ปิดคดี / รีไฟแนนซ์
          </Text>
          <Badge
            count={documents.settlement.length}
            style={{ backgroundColor: "#722ed1" }}
            showZero
          />
        </Space>
      ),
      children: (
        <Card style={{ background: "#fafafa", padding: "16px" }}>
          {documents.settlement.length > 0 ? (
            <List
              dataSource={documents.settlement}
              renderItem={(file, index) => renderFileItem(file, index)}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="ไม่พบเอกสารปิดคดี / รีไฟแนนซ์"
            />
          )}
        </Card>
      ),
    },
  ];

  return (
    <>
      {/* ✅ Search Card */}
      <Card
        style={{
          marginBottom: 20,
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <Row gutter={16} align="middle">
          <Col>
            <Input
              placeholder="กรอกเลขที่สัญญา"
              value={searchInput}
              onChange={(e) => onChangeInputSearchLoad(e.target.value)}
              onPressEnter={handleLoad}
              size="small"
              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
              style={{
                borderRadius: "10px",
                fontSize: 15,
              }}
            />
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="large"
              onClick={handleLoad}
              loading={loading}
              style={{
                borderRadius: "10px",
                fontWeight: "600",
                height: "42px",
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              ค้นหา
            </Button>
          </Col>
        </Row>
      </Card>

      {/* ✅ Content Card */}
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        <Card
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          {dataLoadLoan ? (
            <>
              {/* ✅ Customer Info */}
              <Card
                size="small"
                style={{
                  background:
                    "linear-gradient(135deg, #fdcb6e 0%, #fdcb6e 100%)",
                  borderRadius: "10px",
                  marginBottom: 24,
                  border: "none",
                }}
                bodyStyle={{ padding: "20px" }}
              >
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <Space direction="vertical" size={4}>
                      <Text
                        style={{
                          color: "rgba(255,255,255,0.85)",
                          fontSize: 13,
                        }}
                      >
                        <UserOutlined /> ผู้เช่าซื้อ
                      </Text>
                      <Text strong style={{ color: "#fff", fontSize: 16 }}>
                        {dataLoadLoan.CUSTOMER?.SNAM}{" "}
                        {dataLoadLoan.CUSTOMER?.NAME1}{" "}
                        {dataLoadLoan.CUSTOMER?.NAME2}
                      </Text>
                    </Space>
                  </Col>
                  <Col xs={24} md={12}>
                    <Space direction="vertical" size={4}>
                      <Text
                        style={{
                          color: "rgba(255,255,255,0.85)",
                          fontSize: 13,
                        }}
                      >
                        <TeamOutlined /> ผู้ค้ำประกัน
                      </Text>
                      {dataLoadLoan.GUARANTORS?.length > 0 ? (
                        dataLoadLoan.GUARANTORS.map((guarantor, index) => (
                          <Text
                            key={index}
                            strong
                            style={{
                              color: "#fff",
                              fontSize: 16,
                              display: "block",
                            }}
                          >
                            {index + 1}. {guarantor.SNAM} {guarantor.NAME1}{" "}
                            {guarantor.NAME2}
                          </Text>
                        ))
                      ) : (
                        <Text style={{ color: "#fff", fontSize: 16 }}>
                          ไม่มีผู้ค้ำประกัน
                        </Text>
                      )}
                    </Space>
                  </Col>
                </Row>
              </Card>

              {/* ✅ Documents Section */}
              <Title level={4} style={{ marginBottom: 20 }}>
                📂 เอกสารคดีความ สัญญา {searchInput} {}
              </Title>

              <Collapse
                items={collapseItems}
                defaultActiveKey={["1"]}
                expandIconPosition="end"
                style={{
                  background: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: "12px",
                }}
              />
            </>
          ) : (
            <Empty
              description="กรุณาค้นหาเลขที่สัญญาเพื่อดูเอกสาร"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </Card>
      </Spin>
    </>
  );
};

const FileStoreContno = MotionHoc(Main);
export default FileStoreContno;
